export default __webpack_public_path__ + "static/media/cfdShortImgCN.472ea31d.png";